module.exports = __webpack_public_path__ + "static/img/color.0c85e267.png";